import { owcTheme } from 'core/theme/theme.config';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { ModuleScrollableContent } from 'layout/module/module.layout.style';
import { SettingsViewHeader } from 'modules/settings/settings.style';
import styled from 'styled-components';

export const SettingsFullWidthContentLayoutWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;

    /* TODO: Important! is used to override the default behaviour of workflow overlay content that has a max-width and padding,
    should be removed when the workflow overlay content is refactored to be more flexible and not have those styles by default */
    width: 100% !important;
    max-width: none !important;
    height: 100%;
`;

export const SettingsFullWidthContentLayoutModuleScrollable = styled(ModuleScrollableContent)`
    /* Stick the table header to the top of the scroll area (no top/bottom padding) so rows don't
       bleed above it and the horizontal scrollbar stays flush; a border keeps the title's top
       line (its outline would be clipped at top: 0). */
    /* stylelint-disable-next-line length-zero-no-unit -- consumed inside calc() in custom-table.style.ts */
    --custom-table-header-title-top: 0px;
    --custom-table-header-title-top-border: 1px solid ${owcTheme['one-color-background-contrast']};

    padding: 0 32px;
`;

export const SettingsFullWidthContentLayoutActionsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-left: 16px;
`;

export const SettingsViewHeaderDescription = styled(PocTypography)`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const SettingsFullWidthContentLayoutSettingsViewHeader = styled(SettingsViewHeader)`
    margin-bottom: 4rem;
`;
